"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledgeProject.list': 'Projekty',
    'route.knowledgeProject.create': 'Dodaj projekt',
    'route.knowledgeProject.edit': 'Edytuj projekt',
};
